import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { thunkCreateErrorNotification } from "./NotificationActions";

export const GET_PAGINATED_SEGMENTS = "GET_PAGINATED_SEGMENTS";

export const thunkGetPaginatedSegments = (
  searchText?: string,
  types?: string[],
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: string,
  statuses: string[] = ["READY"]
): BooleanThunk => async (dispatch) => {
  try {
    const response = await Api.getPaginatedSegments(searchText, types, page, size, sortBy, sortDirection, statuses);
    dispatch({
      type: GET_PAGINATED_SEGMENTS,
      payload: response,
    });
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to load segments", e));
    return false;
  }
};